import { campaignMetrics, ChartDataResponse, MetricInfo, MetricLabels } from "@api/common";
import { AppState } from "@store";
import { FetchingState, FETCH_STATE_SUCCESS } from "rd-redux-http";
import { currentReportCampaign } from "./campaignSelector";

export interface TotalMetricInfo {
    value: string;
    color: string;
    name: string;
}

export function reportClicksAndImpressions(state: AppState): TotalMetricInfo[] {
    const reportData: ChartDataResponse = FetchingState.getDataOrDefault(state.reports.chartData.overallData, {
        metrics: [],
        dimensions: []
    });

    const campaign = currentReportCampaign(state);

    const metrics = campaignMetrics(campaign ? campaign.unit : "CPM").filter(m => !m.isRate);

    return metrics.filter(m => !m.isRate).map((m: MetricInfo) => {
        const { metric, color } = m;
        const payload = reportData.metrics.find(e => e.metric == metric);
        const title = MetricLabels.metricSwitcher(m);
        return {
            color,
            name: title,
            value: String(payload && payload.data.length ? payload.data[0]["metric-value"] : 0)
        };
    });
}

export function findCountryIsoCodeForGeographicReportSelector(state: AppState) {
    const regionMetricsData =
        state.reports.chartData.regionData.fetchState === FETCH_STATE_SUCCESS &&
        state.reports.chartData.regionData.data.metrics[0].data;
    const countriesData = state.reports.countries.fetchState === FETCH_STATE_SUCCESS && state.reports.countries.data;

    try {
        const data = regionMetricsData
            .map((d: any) => ({
                regionCode: d["dimension-values"][0]
            }))
            .filter((d: any) => !!d.regionCode);

        const regionCode = data[0].regionCode;

        const selectedCountryIsoCode = countriesData.filter(country =>
            country.regions.some(region => region.iso === regionCode)
        )[0].iso;

        return selectedCountryIsoCode;
    } catch (e) {
        return undefined;
    }
}
